/**
 * Busca digitada dentro do painel dos selects (`.select-busca`).
 *
 * Toda tela que tem select com lista longa usa estas funções para filtrar as opções
 * enquanto a pessoa digita, sem repetir a normalização em cada componente.
 */

/** Deixa o texto em minúscula, sem acento e sem espaço nas pontas. */
export function normalizarTexto(valor: unknown): string {
  return String(valor ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .trim();
}

/**
 * Filtra uma lista de opções pelo termo digitado.
 *
 * Sem `campos`, compara o próprio item (listas de texto). Com `campos`, compara cada
 * campo informado do objeto — por exemplo `['nome', 'sigla']`.
 */
export function filtrarOpcoes<T>(itens: readonly T[], termo: string, campos?: (keyof T)[]): T[] {
  const busca = normalizarTexto(termo);
  const lista = [...(itens ?? [])];

  if (!busca) {
    return lista;
  }

  return lista.filter((item) => {
    if (!campos?.length) {
      return normalizarTexto(item).includes(busca);
    }

    return campos.some((campo) => normalizarTexto(item?.[campo]).includes(busca));
  });
}
